export default {
    api_title: 'ការគ្រប់គ្រងគន្លឹះ API',
    api_key: 'API Key',
};
